/* eslint-disable class-methods-use-this */
import axios from 'axios';
import {
  BASE_API_FORM_TYPE_INT,
  BASE_API_FORM_TYPE_FLOAT,
  BASE_API_FORM_TYPE_STRING,
  BASE_API_FORM_TYPE_DATE,
  BASE_API_FORM_TYPE_DATE_MONTH,
  BASE_API_FORM_TYPE_TIME,
  BASE_API_FORM_TYPE_HTML,
  BASE_API_FORM_TYPE_FILE,
  BASE_API_FORM_TYPE_JSON,
  BASE_API_FORM_TYPE_FILE_ARRAY,
} from './api-constants';
import { formatTimeForApi, formatDateMonthForApi, formatDateForApi } from './api-helpers';
import { convertEditorStateToHtml } from '../../utils/html-utils';
import { APP_STATE_ACTION_TYPE_USER, APP_STATE_ACTION_TYPE_BASE_URL } from '../../state/seed-states';

class BaseApi {
  constructor(state) {
    this.state = state;
    if (this.state) {
      this.baseUrl = this.state[APP_STATE_ACTION_TYPE_BASE_URL];
      this.url = this.state[APP_STATE_ACTION_TYPE_BASE_URL];
      const user = this.state[APP_STATE_ACTION_TYPE_USER];
      if (user) {
        const { token } = user;
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      }
    }
  }

  get(path, config, useUrl = true) {
    return axios.get(useUrl ? `${this.url}/${path}` : path, config);
  }

  post(path, data, config, useUrl = true) {
    return axios.post(useUrl ? `${this.url}/${path}` : path, data, config);
  }

  put(path, data, config, useUrl = true) {
    return axios.put(useUrl ? `${this.url}/${path}` : path, data, config);
  }

  delete(path, config, useUrl = true) {
    return axios.delete(useUrl ? `${this.url}/${path}` : path, config);
  }

  // eslint-disable-next-line class-methods-use-this
  addToData(data, name, value, type) {
    if (type === 'form-data') {
      data.append(name, value);
    } else if (type === 'json') {
      // eslint-disable-next-line no-param-reassign
      data[name] = value;
    }
  }

  prepareData(forms, returnType) {
    let data;
    if (returnType === 'form-data') {
      data = new FormData();
    } else if (returnType === 'json') {
      data = {};
    }
    forms.forEach((form) => {
      if (!form.isOmitted) {
        switch (form.type) {
          case BASE_API_FORM_TYPE_INT:
            this.addToData(data, form.name, parseInt(form.value, 10), returnType);
            break;
          case BASE_API_FORM_TYPE_FLOAT:
            this.addToData(data, form.name, parseFloat(form.value), returnType);
            break;
          case BASE_API_FORM_TYPE_STRING:
            if (form.trim) {
              this.addToData(data, form.name.trim(), form.value, returnType);
            } else {
              this.addToData(data, form.name, form.value, returnType);
            }
            break;
          case BASE_API_FORM_TYPE_DATE:
            this.addToData(data, 'dateFormat', 'YYYY-MM-DD', returnType);
            this.addToData(data, form.name, formatDateForApi(form.value), returnType);
            break;
          case BASE_API_FORM_TYPE_DATE_MONTH:
            this.addToData(data, 'dateFormat', 'YYYY-MM-DD', returnType);
            this.addToData(data, form.name, formatDateMonthForApi(form.value), returnType);
            break;
          case BASE_API_FORM_TYPE_TIME:
            this.addToData(data, 'timeFormat', 'HH;m', returnType);
            this.addToData(data, form.name, formatTimeForApi(form.value), returnType);
            break;
          case BASE_API_FORM_TYPE_HTML:
            this.addToData(data, form.name, convertEditorStateToHtml(form.value), returnType);
            break;
          case BASE_API_FORM_TYPE_FILE:
            this.addToData(data, form.name, form.value, returnType);
            break;
          case BASE_API_FORM_TYPE_JSON:
            this.addToData(data, form.name, JSON.stringify(form.value), returnType);
            break;
          case BASE_API_FORM_TYPE_FILE_ARRAY:
            form.value.forEach((value) => {
              this.addToData(data, form.name, value, returnType);
            });
            break;
          default:
            break;
        }
      }
    });
    return data;
  }

  // eslint-disable-next-line class-methods-use-this
  prepareRawDataPassword(password) {
    let isChangePassword = false;
    if (password.trim() !== '') {
      isChangePassword = true;
    }
    return isChangePassword;
  }
}

export default BaseApi;
